<script lang="ts">
    export let text: string = 'Click me';
    export let disabled: boolean = false;
    export let showIcon: boolean | string = false;
    export let alignIcon: string = 'right';
    export let minWidth: number = 120;
</script>

<button
    class="btn-main dont-break align-icon-{alignIcon}"
    style="min-width: {minWidth}px;"
    class:showIcon
    class:empty={text.length == 0}
    on:click
    {disabled}
>
    {text}
    {#if showIcon}
        <icon style={typeof showIcon == 'string' ? 'background-image: url(' + showIcon + ')' : ''}
        ></icon>
    {/if}
</button>

<style>
    .btn-main {
        min-width: 80px;
        background-color: #4978e2;
        color: #ffffff;
        cursor: pointer;
        border: 1px solid #4978e2;
        border-radius: 5px;
        height: 27px;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        padding: 0 10px;
        margin: 0 6px;
        position: relative;
    }
    .showIcon {
        padding-right: 40px;
        text-align: left;
    }
    .btn-main icon {
        position: absolute;
        right: 5px;
        top: 0;
        height: 100%;
        width: 24px;
        background-image: url('Icons/svg/navigate_next_FILLF_wght400_GRAD0_opsz24.svg');
        background-repeat: no-repeat;
        background-position: 100% center;
        background-size: 24px;
        opacity: 0.6;
    }
    .btn-main.showIcon.align-icon-left {
        padding-left: 30px;
        padding-right: 10px;
    }
    .btn-main.align-icon-left icon {
        right: auto;
        left: 5px;
        background-position: 0% center;
    }
    .btn-main.empty {
        width: 40px;
        min-width: 40px;
    }
    .btn-main.empty icon {
        background-position: center center;
        opacity: 1;
        padding: 0;
        margin: 0;
    }

    /*.btn-main:hover {*/
    /*    opacity: 0.8;*/
    /*    transition: 0.2s;*/
    /*}*/
    .btn-main[disabled] {
        background-color: var(--automapa-grey-dark);
        cursor: not-allowed;
        border: 1px solid var(--automapa-grey-dark);
    }
</style>
